<!-- 采编名片 -->
<template>
  <div class="card">
    <div v-if="haveNoData" class="haveNoData">
      <img src="@/assets/image/noData.png" height="100"/>
      <p>该名片不存在</p>
    </div>
    <div class="card-item" v-else>
      <div class="card-item-content">
        <div class="top">
          <div class="left">
            <img
              class="zazhi"
              v-if="myCard.perLogo"
              :src="$global.imgUrl + myCard.perLogo"
              alt=""
            />
            <span class="title">{{ myCard.perName }}</span>
            <div class="text">
              <span class="name">{{ myCard.name }}</span>
              <!-- <span class="position">{{ myCard.editType == 1 ? "采编" : "组稿人" }}</span> -->
              <span class="position">{{ myCard.post }}</span>
            </div>
            <div class="phone">
              {{ myCard.phone }}
              <span v-if="myCard.wxPhone">（微信同号）</span>
            </div>
            <p class="phone">
              QQ：{{ myCard.qq }} <span v-if="myCard.qq == ''">无</span>
            </p>
          </div>
          <div class="right">
            <img
              v-if="myCard.perImg"
              :src="$global.imgUrl + myCard.perImg"
              alt=""
            />
          </div>
        </div>
        <div class="line"></div>
        <div class="main">
          <!-- <div class="wxcode">
            <img :src="$global.imgUrl + myCard.websiteCode" alt="" />
          </div> -->
          <div class="company">
            <div class="company-z">
              {{ myCard.stampName }}
            </div>
            <div class="company-y">
              {{ myCard.website }}
            </div>
          </div>
        </div>
        <div class="bottom" v-if="path !== '' && path !== 'modifyCard'">
          <div class="left">
            <img src="../../public/mobileImg/icon13.png" alt="" />
            <span>分享名片</span>
          </div>
          <div class="right" @click="modify">
            <img src="../../public/mobileImg/icon4.png" alt="" />
            <span>修改名片</span>
          </div>
        </div>
        <div
          class="bottom"
          v-if="path !== '' && path !== 'myCard' && path !== 'modifyCard'"
        >
          <div
            class="left"
            @click="consult"
            :class="userId == editId ? 'zhe' : ''"
          >
            <img src="../../public/mobileImg/icon9.png" alt="" />
            <span>咨询</span>
            <span class="badge" v-if="myCard.unread !== 0 && myCard.unread">{{
              myCard.unread
            }}</span>
          </div>
          <div
            class="right"
            @click="openModal()"
            :class="userId == editId ? 'zhe' : ''"
          >
            <img src="../../public/mobileImg/icon4.png" alt="" />
            <span>投稿</span>
          </div>
        </div>
        <div
          class="bottom"
          v-if="path === '' && path !== 'myCard' && path !== 'modifyCard'"
        >
          <div class="left" :class="userId == editId ? 'zhe' : ''">
            <img
              v-if="myCard.isCollection != 1"
              src="../../public/mobileImg/icon8.png"
              alt=""
            />
            <Icon v-else type="ios-star" size="20" color="#2150cb" />
            <span v-if="myCard.isCollection != 1" @click="collection"
              >收藏</span
            >
            <span v-else>已收藏</span>
          </div>
          <div
            class="right"
            @click="consult"
            :class="userId == editId ? 'zhe' : ''"
          >
            <img src="../../public/mobileImg/icon9.png" alt="" />
            <span> 咨询 </span>
            <span class="badge" v-if="myCard.unread !== 0 && myCard.unread">{{
              myCard.unread
            }}</span>
          </div>
        </div>
        <div
          class="bottom"
          v-if="path !== '' && path !== 'myCard' && path !== 'modifyCard'"
        >
          <div class="right" @click="openModal()">
            <img src="../../public/mobileImg/icon4.png" alt="" />
            <span>投稿</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 投稿提醒组件 -->
    <contributeModal
      :showModal="showModal"
      :journalName="journalName"
      @closeModal="showModal = false"
    />
    <Modal
      v-model="modal"
      :title="modalTitle"
      :mask-closable="false"
      :closable="false"
      :footer-hide="true"
      class-name="vertical-center-modal"
    >
      <div class="card-item">
        <div class="card-item-content">
          <div class="top" @click="jumpCard">
            <div class="left">
              <img
                class="zazhi"
                v-if="handoverCard.perLogo"
                :src="$global.imgUrl + handoverCard.perLogo"
                alt=""
              />
              <span class="title">{{ handoverCard.perName }}</span>
              <div class="text">
                <span class="name">{{ handoverCard.name }}</span>
                <span class="position">{{
                  handoverCard.editType == 1 ? "采编" : "组稿人"
                }}</span>
              </div>
              <div class="phone">
                {{ handoverCard.phone }}
              </div>
            </div>
            <div class="right">
              <img
                v-if="handoverCard.perImg"
                :src="$global.imgUrl + handoverCard.perImg"
                alt=""
              />
            </div>
          </div>
          <div class="line"></div>
          <div class="main">
            <!-- <div class="wxcode">
            <img :src="$global.imgUrl + handoverCard.websiteCode" alt="" />
          </div> -->
            <div class="company">
              <div class="company-z">
                {{ handoverCard.stampName }}
              </div>
              <div class="company-y">
                {{ handoverCard.website }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="return-card"><a @click="returnCard">返回名片夹</a></div>
    </Modal>
  </div>
</template> 

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import contributeModal from "@/components/contribute_modal";
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { contributeModal },
  props:["userBehaviorData"],
  data() {
    
    //这里存放数据
    return {
      haveNoData:false,
      modal: false,
      modalTitle:
        "名片已停用， 如果您是作者想给本刊投稿或查询进度，点击下方名片与采编联系",
      // editId: "1446352177927950336", // 后期从url中获取
      editId: this.$route.query.editId,
      // perId: "1297783010043576320", // 后期从url中获取
      perId: this.$route.query.perId,
      userId: JSON.parse(sessionStorage.getItem("userInfo"))
        ? JSON.parse(sessionStorage.getItem("userInfo")).user.id
        : "",
      path: "", //路由地址
      myCard: {}, // 期刊列表
      handoverCard: {}, // 交接人名片
      journalName: "", // 期刊名字
      showModal: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 用户点击行为统计
    statisticUserBehavior(btnName) { 
      this.userBehaviorData.clickName = btnName;
      this.$apis.manage
      .userBehaviorStatistics(this.userBehaviorData)

    },
    // 返回名片夹
    returnCard() {
      let token = sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          path: "/cardCollection",
          query: {
            perId: this.$route.query.perId,
            editId: this.$route.query.editId,
          },
        });
      } else {
        this.$Message.error("请登录后查看名片夹!");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
            query: {
              perId: this.$route.query.perId,
              editId: this.$route.query.editId,
            },
          });
        }, 1000);
      }
    },
    // 跳转交接人期刊
    jumpCard() {
      let url = window.location.href.split("?")[0];
      window.location.replace(
        `${url}?editId=${this.handoverCard.userId}&perId=${this.handoverCard.perId}`
      );
    },
    // 收藏
    collection() {
      this.statisticUserBehavior("收藏")
      if (this.userId == this.editId) {
        return;
      }
      let token = sessionStorage.getItem("token");
      if (token) {
        this.$apis.manage
          .collections({
            editId: this.editId,
            perId: this.perId,
            userId: JSON.parse(sessionStorage.getItem("userInfo")).user.id,
            userName: JSON.parse(sessionStorage.getItem("userInfo")).user
              .username,
          })
          .then((result) => {
            this.$Message.success("收藏" + result.resultDesc);
            this.getCard();
          })
          .catch((err) => {
            // console.log(err);
          });
      } else {
        this.$Message.error("请登录后收藏!");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
            query: {
              perId: this.$route.query.perId,
              editId: this.$route.query.editId,
            },
          });
        }, 1000);
      }
    },
    // 咨询
    consult() {
      this.statisticUserBehavior("咨询")
      if (this.userId == this.editId) {
        return;
      }
      let token = sessionStorage.getItem("token");
      if (token) {
        if (this.myCard.hasOwnProperty("groupId")) {
          this.$router.push({
            path: "/consult",
            query: {
              name: this.myCard.name,
              perName: this.myCard.perName,
              perId: this.myCard.perId,
              groupId: this.myCard.groupId,
              userId: this.myCard.userId,
              perLogo: this.myCard.perLogo,
            },
          });
        } else {
          this.$router.push({
            path: "/consult",
            query: {
              name: this.myCard.name,
              perName: this.myCard.perName,
              perId: this.myCard.perId,
              groupId: "",
              userId: this.myCard.userId,
              perLogo: this.myCard.perLogo,
            },
          });
        }
      } else {
        this.$Message.error("请登录后咨询!");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
            query: {
              perId: this.$route.query.perId,
              editId: this.$route.query.editId,
            },
          });
        }, 1000);
      }
    },
    // 打开投稿弹窗
    openModal() {
      this.statisticUserBehavior("投稿")
      if (this.perInfo.name === undefined) {
        // this.$Message.error('投稿失败,请重试')
        return;
      }
      this.journalName = "";
      if (sessionStorage.getItem("token")) {
        if (this.perInfo.cn === "" || this.perInfo.contribute === 0) {
          this.journalName = this.perInfo.name;
        }
        this.showModal = true;
      } else {
        this.$Message.error("还没有登录,请登录");
      }
    },
    soucang() {
      this.getCard();
    },
    // 修改名片
    modify() {
      this.$router.push({
        path: "/modifyCard",
        params: {
          // 参数
        },
      });
    },
    // 获取路由
    getRouter() {
      this.path = this.$router.history.current.name;
    },
    // 获取名片信息
    getCard() {
      let _this = this;
      this.$apis.manage
        .detailsLive({
          editId: this.$route.query.editId,
          perId: this.$route.query.perId,
          userId: this.userId ? this.userId : "",
        })
        .then((result) => {
         if(result.resultCode != 200 && result.resultDesc == "名片不存在！"){
            _this.haveNoData = true;
          }
          this.$emit("cardlists", result.data.cardId);
          this.myCard = result.data;
          axios
            .post(
              "https://wxtest.cnknowledge.com/api/zw-wechat/wx/nf/getSignature",
              { url: location.href.split("#")[0] },
              {
                headers: {
                  rsa: "no",
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log(response);
              var appId = response.data.data.appId;
              var timestamp = response.data.data.timestamp;
              var nonceStr = response.data.data.nonceStr;
              var signature = response.data.data.signature;

              wx.config({
                // debug: true,
                appId: appId,
                timestamp: timestamp,
                nonceStr: nonceStr,
                signature: signature,
                jsApiList: [
                  "checkJsApi",
                  "onMenuShareTimeline", //分享到微信朋友圈
                  "onMenuShareAppMessage", //分享给微信朋友
                  "onMenuShareQQ", //分享到QQ
                  "onMenuShareQZone", //分享到QQ空间
                  "updateAppMessageShareData",
                  "updateTimelineShareData",
                ],
              });
              wx.ready(function () {
                // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容 （1.4.0）
                wx.updateAppMessageShareData({
                  title: `${_this.myCard.perName} - ${_this.myCard.name}`, // 分享标题 期刊名-采编名
                  desc: _this.$store.periodicalIntro, // 分享描述
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: `${_this.$global.imgUrl + _this.myCard.perLogo}`, // 分享图标
                  success: function () {
                    // 设置成功
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  },
                });
                // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                wx.updateTimelineShareData({
                  title: `${_this.myCard.perName} - ${_this.myCard.name}`, // 分享标题
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: `${_this.$global.imgUrl + _this.myCard.perLogo}`, // 分享图标
                  success: function () {
                    // 设置成功
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  },
                });
              });
            });
          sessionStorage.setItem("cardInfo", JSON.stringify(result.data));
          if (result.data.enable == 0) {
            setTimeout(() => {
              _this.$apis.manage
                .detailsLive({
                  editId: result.data.handoverId,
                  perId: result.data.perId,
                })
                .then((res) => {
                  if(res.resultCode == 200){
                    _this.handoverCard = res.data;
                  }
                })
                .catch((err) => {});
            }, 0);
            _this.modal = true;
          }
        })
        .catch((err) => {});
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getRouter();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getCard();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.return-card {
  text-align: center;
  height: 40px;
  line-height: 30px;
}
.ivu-modal-body .card-item {
  padding: 0;
  border-radius: 6px;
}
/deep/.ivu-modal-body {
  padding: 0 !important;
}
/deep/.ivu-modal-content {
  margin-top: 100px;
}
//@import url(); 引入公共css类
/deep/ .ivu-modal-header-inner {
  display: inline-block;
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #17233d;
  font-weight: 500;
  overflow: inherit !important;
  text-overflow: none !important;
  white-space: pre-wrap !important;
  text-align: center;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.card-item {
  padding: 28px 18px 28px 18px;
  box-sizing: border-box;
  background: #f6f6f6;
}
.card-item-content {
  width: 100%;
  background: #fff;
  border-radius: 9px;

  .top {
    // height: 200px;
    padding: 20px 18px 20px 18px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .left {
      min-width: 200px;
      .zazhi {
        width: 44px;
        height: 44px;
        margin-right: 8px;
        border-radius: 50%;
      }
      .title {
        display: inline-block;
        // font-family: PingFang SC;
        font-weight: bold;
        width: 160px;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .text {
        width: 100%;
        margin-top: 5px;
        padding-left: 52px;
        .name {
          font-size: 21px;
          color: #333333;
        }
        .position {
          margin-left: 11px;
          font-size: 13px;
          color: #999999;
        }
      }
      .phone {
        font-size: 13px;
        color: #999999;
        padding-left: 52px;
        margin-top: 13px;
      }
    }
    .right {
      img {
        width: 87px;
        height: 114px;
      }
    }
  }
  .line {
    width: 90%;
    height: 1px;
    background: #e6e6e6;
    margin: 0 auto;
  }
  .main {
    display: flex;
    padding: 20px 18px;
    .wxcode {
      margin-right: 7px;
      img {
        width: 34px;
        height: 34px;
        vertical-align: bottom;
      }
    }
    .company {
      .company-z {
        font-size: 13px;
        font-family: PingFang SC;
        color: #333333;
      }
      .company-y {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 13px;
      }
    }
  }
  .bottom {
    height: 52px;
    border-top: 1px solid #e6e6e6;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      border-right: 1px solid #e6e6e6;
      img {
        width: 16px;
        height: 16px;
        margin-right: 7px;
      }
      span {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #2150cb;
      }
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      position: relative;
      img {
        width: 16px;
        height: 16px;
        margin-right: 7px;
      }
      span {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #2150cb;
      }
      .badge {
        display: block;
        height: 15px;
        min-width: 15px;
        background-color: #2150cb;
        color: #fff;
        text-align: center;
        line-height: 15px;
        border-radius: 25px;
        font-size: 10px;
        position: absolute;
        right: 40px;
        top: 10px;
      }
    }
  }
}
.haveNoData{
  width: 100%;
  background: #fff;
  height: 200px;
  text-align: center;
  padding-top: 10px;
  margin-bottom: 10px;
}
.haveNoData p{
  font-size: 15px;
  font-weight: bold;
  margin-top: 10px;
}
</style>
